export * from './vorlage-entfernt.interface';
